import { render, staticRenderFns } from "./dashboardfinanciero.vue?vue&type=template&id=caad3bcc&scoped=true&"
import script from "./dashboardfinanciero.vue?vue&type=script&lang=js&"
export * from "./dashboardfinanciero.vue?vue&type=script&lang=js&"
import style0 from "./dashboardfinanciero.vue?vue&type=style&index=0&id=caad3bcc&class=cp-pen-styles&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caad3bcc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VCol,VContainer,VFlex,VImg,VLayout,VListItem,VListItemContent,VListItemSubtitle,VListItemTitle,VSelect,VToolbar,VToolbarTitle})
